module.exports = __webpack_public_path__ + "img/biominder-mouse-wire.ebd55ed7.png";